import { createRoute, redirect } from "@tanstack/react-router";
import { Route as patientLayout } from "./patient-layout";

export const Route = createRoute({
  getParentRoute: () => patientLayout,
  path: "/connections",
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/dashboard/patients/$patientId/onboarding/$tab",
      params: { patientId: params.patientId, tab: "connected-systems" },
      replace: true,
    });
  },
});
